// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */[data-v-165e322d] .agile__actions{margin-top:1.6rem}[data-v-165e322d] .agile__dots{grid-gap:.8rem;gap:.8rem}[data-v-165e322d] .agile__slide{margin-right:1.2rem}[data-v-165e322d] .agile__dots .agile__dot button{box-sizing:content-box;width:6px;height:6px;border-radius:9999px;border:none;padding:0}[data-v-165e322d] .agile__dots .agile__dot.agile__dot--current button{background-color:#1f232b}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
